import { render, staticRenderFns } from "./ProjectViewTemplate.vue?vue&type=template&id=763a8d84&scoped=true&"
import script from "./ProjectViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a8d84",
  null
  
)

export default component.exports